// useUserPermissions.tsx
import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const rankMapping: Record<string, number> = {
  CopperApprentice: 5,
  ObsidianArtificer: 4,
  AmberSentinel: 3,
  OnyxOverlord: 2,
  AdamantineParagon: 1,
};

export const useUserPermissions = () => {
  const [userRanks, setUserRanks] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const role = Cookies.get("role");
    const roles = Cookies.get("roles");
    const token = Cookies.get("token");

    // Admin jog ellenőrzése
    if (role === "ADMIN" || roles === "ADMIN") {
      setIsAdmin(true);
    }

    // Csak bejelentkezett felhasználóknak
    if (!token) {
      setLoading(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_URL}/v1/auth/getranks`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Unauthorized");
        }
        return response.json();
      })
      .then((data: string[]) => {
        setUserRanks(data);
        setLoading(false);
      })
      .catch((err) => {
        // Ha lejárt/invalid token, töröljük
        Cookies.remove("token");
        Cookies.remove("role");
        Cookies.remove("roles");
        setError("Hiba a jogosultság lekérdezésekor");
        setLoading(false);
      });
  }, []);

  const hasPermission = (requiredRank: string): boolean => {
    if (isAdmin) return true;
    const requiredValue = rankMapping[requiredRank];
    return userRanks.some((rank) => {
      const userValue = rankMapping[rank];
      if (userValue === undefined) return false;
      return userValue <= requiredValue;
    });
  };

  return { userRanks, loading, error, isAdmin, hasPermission };
};